import React, { useContext, useLayoutEffect, useState } from 'react';
import { IoIosArrowBack } from 'react-icons/io';

import * as S from './styles';
import ScreensStaticContext from 'context/ScreensStaticContext';
import { ScreenCampaignType } from 'types/ScreenCampaignType';
import CarouselImgCampaign from './CarouselImgCampaign';
import CarrosselProductsScreenStatics from 'components/CarrosselProductsScreenStatics';
import CarouselBrandsCampaign from './CarouselBrandsCampaign';

export default function BodyCampaign() {
	const { screens } = useContext(ScreensStaticContext);

	const [campaign, setCampaign] = useState<ScreenCampaignType | null>(null);

	useLayoutEffect(() => {
		if (screens.length > 0) {
			const screen = screens.find((screen) => screen.type === 'campaign');
			if (screen) {
				setCampaign((screen.data as ScreenCampaignType) || null);
			}
		}
	}, [screens]);

	return campaign ? (
		<S.container>
			{campaign.firstTitleCampaign !== '' ? (
				<S.firstTitle>
					<IoIosArrowBack />
					<p>{campaign.firstTitleCampaign}</p>
				</S.firstTitle>
			) : (
				<S.noData>
					<p>Primeiro título não configurado</p>
				</S.noData>
			)}

			{campaign.secondTitleCampaign !== '' ? (
				<S.secondTitle>
					<p>{campaign.secondTitleCampaign}</p>
				</S.secondTitle>
			) : (
				<S.noData>
					<p>Segundo título não configurado</p>
				</S.noData>
			)}

			{campaign.mainImageCampaign.urlImage !== '' ? (
				<S.roundImg>
					<img
						src={campaign.mainImageCampaign.urlImage}
						alt={campaign.mainImageCampaign?.urlImage || ''}
					/>
				</S.roundImg>
			) : (
				<S.noData>
					<p>Primeira imagem não configurada</p>
				</S.noData>
			)}

			{campaign.carouselImagesCampaign.length > 0 ? (
				<S.box>
					<CarouselImgCampaign imgs={campaign.carouselImagesCampaign} />
				</S.box>
			) : (
				<S.noData>
					<p>Carrossel não configurado</p>
				</S.noData>
			)}

			{campaign.queryListProductsCampaign !== '' ? (
				<S.box>
					<CarrosselProductsScreenStatics
						query={campaign.queryListProductsCampaign}
					/>
				</S.box>
			) : (
				<S.noData>
					<p>Primeira query não configurada</p>
				</S.noData>
			)}

			{campaign.secondMainImageCampaign.urlImage !== '' ? (
				<S.roundImg>
					<img
						src={campaign.secondMainImageCampaign.urlImage}
						alt={campaign.secondMainImageCampaign?.urlImage || ''}
					/>
				</S.roundImg>
			) : (
				<S.noData>
					<p>Segunda imagem não configurada</p>
				</S.noData>
			)}

			{campaign.secondQueryListProductsCampaign !== '' ? (
				<S.box>
					<CarrosselProductsScreenStatics
						query={campaign.secondQueryListProductsCampaign}
					/>
				</S.box>
			) : (
				<S.noData>
					<p>Segunda query não configurada</p>
				</S.noData>
			)}

			{campaign.brandsCarousel.brands.length > 0 ? (
				<S.box>
					<CarouselBrandsCampaign
						imgs={campaign.brandsCarousel.brands}
						title={campaign.brandsCarousel.title || ''}
					/>
				</S.box>
			) : (
				<S.noData>
					<p>Carrossel de marcas não configurado</p>
				</S.noData>
			)}

			{campaign.thirdMainImageCampaign.urlImage !== '' ? (
				<S.fullImg>
					<img
						src={campaign.thirdMainImageCampaign.urlImage}
						alt={campaign.thirdMainImageCampaign.urlImage || ''}
					/>
				</S.fullImg>
			) : (
				<S.noData>
					<p>Terceira imagem não configurada</p>
				</S.noData>
			)}

			{campaign.footer.title !== '' && campaign.footer.description !== ' ' ? (
				<S.box>
					<S.footer>
						<h2>{campaign.footer.title}</h2>
						<p>{campaign.footer.description}</p>
					</S.footer>
				</S.box>
			) : (
				<S.noData>
					<p>Texto e descrição não configurados</p>
				</S.noData>
			)}
		</S.container>
	) : (
		<></>
	);
}
